export default "__VITE_ASSET__COBIHckI__$_?nuxt_component=async&nuxt_component_name=IUsdgLogoUsimsaLogoBlackIcon__"